import { LoadFonts } from "@/components/atoms/load-fonts";
import { MasonryGallery } from "../testimonial-gallery/components/masonary";
import { TestimonialWallHero } from "./components/hero";
import { MasonryGalleryCustomProps } from "../testimonial-gallery/api/types";
import { WidgetComponent } from "@/types";
import { useGetSocialProofAssetById } from "../testimonial-gallery/api/queries";

export const MasonryWallOfLovePageComponentWidget: WidgetComponent = ({
  widgetId,
}) => {
  const { data, isPending } =
    useGetSocialProofAssetById<MasonryGalleryCustomProps>({ id: widgetId });

  if (!data || isPending) return;

  return (
    <main
      className="testify-w-full"
      style={{ background: data.properties.secondaryColor }}
    >
      <LoadFonts font={data.properties.font} />
      <TestimonialWallHero {...data.properties} />
      <section className="testify-pb-12 testify-min-h-screen">
        <MasonryGallery
          projectId={data.projectId!}
          properties={data.properties}
          variant={data.properties.cardVariant}
        />
      </section>
    </main>
  );
};
